import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import UnitDetailsIconButton from "./UnitDetailsIconButton";

export interface StorageUnitsButtonProps {
  active: boolean;
  onClick: () => void;
}

export default function StorageUnitsButton(props: StorageUnitsButtonProps) {
  return (
    <UnitDetailsIconButton
      active={props.active}
      onClick={props.onClick}
      tooltip="Documentation"
    >
      <ImageOutlinedIcon sx={{ height: 24, width: 24 }} />
    </UnitDetailsIconButton>
  );
}
